export const NEXT_CLOUD_QOE = "NextCloud QOE";

export const OVERVIEW = "Overview"
